export enum RecommendationType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
  OTHER = 'OTHER',
  NONE = 'NONE'
}
